import AppLayout from "../../../shared/components/AppLayout";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import ChallengeEnginePanel from "../components/ChallengeEnginePanel";

export default function SuperTwelvePage() {
  return (
    <AppLayout>
      <ChallengeEnginePanel
        title={siteTexts.challenges.modes.challenge.title}
        description={siteTexts.challenges.modes.challenge.description}
        mode="admin"
        challengeType="challenge"
      />
    </AppLayout>
  );
}
